var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),_c('div',{ref:"tooltip",staticClass:"popover"},[_vm._t("content"),_vm._v(" "+_vm._s(_vm.title)+" ")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }